import { AxiosConfig } from '../../../componentes/axiosConfig';

export class ListarUsuariosCliente {
    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();

        this._idContainerUsuarios = 'container-usuarios-cliente';
        this._idBtnListarUsuarios = 'btn-listar-usuarios';
    }

    executar() {
        const _this = this;
        const containerUsuarios  = $(`#${this._idContainerUsuarios}`);
        const btnLlistarUsuarios = document.getElementById(this._idBtnListarUsuarios);
        if (!btnLlistarUsuarios) {
            return;
        }

        btnLlistarUsuarios.addEventListener('click', (evento) => {
            this._listar();
            evento.preventDefault();
        });

        /**
         * Na tela de cadastro e atualização do usuário do cliente, tem o botão cancelar, ao clicar
         * nesse botão essa operação é executada.
         */
        containerUsuarios.on('click', `#${this._idBtnListarUsuarios}`, function (event) {
            _this._listar();
            event.preventDefault();
        });
    }

    /**
     * Exibe a tabela de listagem dos usuários do cliente
     */
    _listar() {
        try {
            const usuariosClienteContainer = document.getElementById(this._idContainerUsuarios);
            const btnLlistarUsuarios       = document.getElementById(this._idBtnListarUsuarios);

            this._axios.get(btnLlistarUsuarios.getAttribute('data-href'))
            .then((response) => {
                usuariosClienteContainer.innerHTML = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        }
        catch (error) {
            console.log(error);
        }
    }
}
